import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useDisabledState } from 'common/disabled-context';
import { isFieldPathTouched } from 'common/components/farm/locations/helpers';

export const useActiveFormState = (fieldName) => {
  const { touched, dirty, setTouched } = useFormikContext();
  const { setActiveForm, activeForm, disabled } = useDisabledState();

  const disableForm = Boolean(disabled || (activeForm && activeForm !== fieldName));

  useEffect(() => {
    if (!dirty && activeForm !== null) {
      setActiveForm(null);
      setTouched({});
      return;
    }

    const isBeingEdited = isFieldPathTouched(touched, fieldName);
    if (isBeingEdited && activeForm !== fieldName) {
      setActiveForm(fieldName);
    }
  }, [dirty, fieldName]);

  return {
    setActiveForm,
    activeForm,
    disableForm
  };
};
